import createDisplayName from "../../../../fabrics/createDisplayName";
import { HEADER_SHOW_ALL_DISPLAY_NAME } from "../HeaderShowAll";

export const createDisplayNameForHeaderShowAll = createDisplayName(
    HEADER_SHOW_ALL_DISPLAY_NAME,
);
